import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { store } from "@/store";

import App from "./app/App";
import "@/i18n";
import "@/styles/styles.scss";
import "@amzn/meridian-tokens/base/font/amazon-ember.css";

// Render TCP header/footer mock in local dev (mimics HorizonteYamsTCPWebApp chrome)
if (process.env.NODE_ENV === "development") {
  const TcpHeaderMock = require("./app/components/TcpHeaderMock").default;
  const TcpFooterMock = require("./app/components/TcpHeaderMock/TcpFooterMock").default;

  const headerRoot = document.createElement("div");
  document.body.insertBefore(headerRoot, document.getElementById("app"));
  createRoot(headerRoot).render(<TcpHeaderMock />);

  const footerRoot = document.createElement("div");
  document.body.appendChild(footerRoot);
  createRoot(footerRoot).render(<TcpFooterMock />);
}

const container = document.getElementById("app");
const root = createRoot(container || null);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={window.location.pathname.split("/")[1] || ""}>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <App />
        </QueryParamProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// Expose store when run in Cypress
// window.parent because for some reason, when testing against CloudFront URLs, window.Cypress is undefined for Chrome and Electron (but strangely not for Firefox), but window.parent.Cypress is present
// Reference: https://github.com/cypress-io/cypress/issues/2383#issuecomment-973135002
if (window.Cypress || window.parent.Cypress) {
  window.store = store;
}
